/* Игра во время матча: вопрос на овер и «Болеем» — тот же стиль вариантов, что у прогноза. */
.wrap { display: flex; flex-direction: column; gap: var(--space-3); margin-top: var(--space-3); padding-top: var(--space-3);
  border-top: 0.5px solid var(--content-border); }
.head { display: flex; align-items: center; gap: 6px; font-size: var(--fs-footnote); font-weight: 600; color: var(--live-ink);
  }
:global(:root[data-lang='en']) .head { text-transform: uppercase; letter-spacing: 0.2px; }
.dot { width: 8px; height: 8px; border-radius: 50%; background: var(--live); animation: blink 1.4s ease-in-out infinite; }
@keyframes blink { 50% { opacity: 0.3; } }
.block { display: flex; flex-direction: column; gap: var(--space-2); }
.qHead { display: flex; align-items: baseline; gap: var(--space-2); }
.qTitle { flex: 1; min-width: 0; font-size: var(--fs-subheadline); font-weight: 600; }
.reward { flex: none; padding: 2px 8px; border-radius: 10px; background: color-mix(in srgb, var(--accent) 30%, transparent);
  font-size: var(--fs-caption); font-weight: 700; white-space: nowrap; }
.buckets { display: grid; grid-template-columns: repeat(3, 1fr); gap: var(--space-2); }
.bucket { justify-content: center; min-height: 48px; }
.bucketTitle { font-size: var(--fs-callout); font-weight: 700; }
.summary { font-size: var(--fs-footnote); font-weight: 600; }
.overRow { display: flex; align-items: center; gap: var(--space-2); font-size: var(--fs-footnote); color: var(--content-sub-primary); }
.overWon { color: var(--content-primary); }
.muted { color: var(--content-secondary); }
.mark { margin-left: auto; font-weight: 700; }
.overWon .mark { color: var(--positive); }

.meter { display: flex; height: 8px; border-radius: 4px; overflow: hidden; background: var(--ground); }
.meter_home { background: var(--accent); transition: width 0.4s ease; }
.meter_away { background: var(--purple); transition: width 0.4s ease; }
.sides { display: grid; grid-template-columns: 1fr 1fr; gap: var(--space-2); }
.side { position: relative; display: flex; flex-direction: column; align-items: center; gap: 4px; padding: var(--space-3) var(--space-2);
  border-radius: var(--radius-button); background: var(--ground); touch-action: manipulation; user-select: none; }
.side:active:not(:disabled) { transform: scale(0.96); }
.side:disabled { opacity: 0.5; }
.sideName { max-width: 100%; font-size: var(--fs-footnote); font-weight: 600; text-align: center; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.sidePct { font-size: var(--fs-callout); font-weight: 700; }
.pop { position: absolute; top: 34px; right: 16px; font-family: var(--font-score); font-weight: 800; color: var(--accent-ink);
  pointer-events: none; animation: pop 0.7s ease-out forwards; }
@keyframes pop { from { opacity: 1; transform: translateY(0) scale(1); } to { opacity: 0; transform: translateY(-22px) scale(1.3); } }
.bonus { color: var(--content-primary); font-weight: 600; }
@media (prefers-reduced-motion: reduce) { .dot, .pop { animation: none; } }
